/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiInvitationFromJSON, StreemApiInvitationToJSON, } from './';
export function StreemApiGetCurrentInvitationResponseFromJSON(json) {
    return StreemApiGetCurrentInvitationResponseFromJSONTyped(json, false);
}
export function StreemApiGetCurrentInvitationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'invitation': !exists(json, 'invitation') ? undefined : StreemApiInvitationFromJSON(json['invitation']),
    };
}
export function StreemApiGetCurrentInvitationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'invitation': StreemApiInvitationToJSON(value.invitation),
    };
}
//# sourceMappingURL=StreemApiGetCurrentInvitationResponse.js.map